import React, { useEffect, useState } from 'react';
import { Form, FormElement, Field } from '@progress/kendo-react-form';
import { Button } from '@progress/kendo-react-buttons';
import {
  FormTextArea,
  FormDatePicker,
  FormCheckbox
} from "src/shared/components/formControls";
import { required } from 'src/shared/validators/validator';
import HoldTypeDropdown from 'src/shared/components/dropdowns/HoldTypeDropdown';
import FormInput from 'src/shared/components/forms/FormInput';
import { holdInventoryUnits } from 'src/fetch/inventoryUnit';
import toastr from 'shared/helpers/toastr';
import errorToastr from 'shared/helpers/errorToastr';
import isNil from 'lodash/isNil';
import { useSelector } from 'react-redux';
import { getHoldTypes } from 'src/slices/holdTypes';
import { getDateStringForRequest } from 'shared/../helpers/date';

const HoldsForm = ({
  data,
  onClose,
}) => {
  const holdTypes = useSelector(getHoldTypes);

  const emptyHold = {
    type: holdTypes[0],
    date: getDateStringForRequest(new Date()),
  };

  const [hold] = useState(!isNil(data.hold?.id) ? data.hold : emptyHold);
  const [applyHoldToAll, setApplyHoldToAll] = useState(false);

  const convertValuesToSubmit = ({
    type,
    ...others
  }) => ({
    type: typeof type === 'object' ? type?.value : type,
    ...others,
  });

  const handleSubmit = async (hold) => {
    hold = convertValuesToSubmit(hold);
    hold.inventoryUnitId = data.id;
    let request = [hold];

    if (applyHoldToAll) {
      data.children.filter(g => g.id !== data.id).forEach(item => {
        let currHold = { ...hold };
        currHold.inventoryUnitId = item.id;
        request.push(currHold);
      });
    }

    await holdInventoryUnits(request).then(() => {
      toastr('success', 'Successfully updated cargo');
      onClose(true);
    }).catch((error) => {
      errorToastr({
        error,
        messagePrefix: 'Failed to update cargo!'
      });
    }
    );
  };

  const handleCancelClick = () => {
    onClose(false);
  };

  const onApplyToAllChange = (change) => {
    setApplyHoldToAll(change.value);
  };

  return (
    <Form onSubmit={handleSubmit}
      initialValues={hold}
      key={JSON.stringify(hold)}
      id='holds'
      render={(formRenderProps) => (
        <FormElement>
          <fieldset className={"k-form-fieldset"}>

            {data.children && data.children.length > 0 && (
              <>
                <FormCheckbox value={applyHoldToAll} onChange={onApplyToAllChange} label={`Apply Hold to all grouped MRs (${data.children.map(g => g.id).join(', ')})`} />
              </>
            )}

            <Field id={'type'} name={'type'} label={'Type'} component={FormInput} inputComponent={HoldTypeDropdown} />
            <Field id={'description'} name={'description'} label={'Description'} component={FormInput} />
            <Field id={'date'} name={'date'} label={'Hold Date'} component={FormDatePicker} validator={required} />
            <Field id={'releaseDate'} name={'releaseDate'} label={'Release Date'} component={FormDatePicker} />
            <Field id={'notes'} name={'notes'} label={'Notes'} component={FormTextArea} />

            <div className="k-form-buttons">
              <Button primary icon="cancel" onClick={handleCancelClick} style={{ marginRight: '10px' }}>Cancel</Button>
              {<Button primary icon="save" type={'submit'} disabled={!formRenderProps.allowSubmit}>Save</Button>}
            </div>

          </fieldset>
        </FormElement>
      )}>
    </Form>
  );
};

export default HoldsForm;
